import { BACKUP_API } from "../vars";
import { showDangerToast, showInfoToast, showSuccessToast } from "../validation/ToastContainer";
import { getAuthHeader } from "../auth/authService";
import fileSaver from 'file-saver';

//Execute and Download App database backup to the
//default download Dir at the user machine
export async function downloadDatabaseBackup() {
    const filename = new Date().toISOString() + '.backup'

    //const token = localStorage.getItem('access_token');
    const token = sessionStorage.getItem('access_token');

    const serverResponse = await fetch(`${BACKUP_API}?_ticket=${token}`, {
        method: 'GET',
        headers: {
            'Content-Type': 'application/json',
            'Authorization': 'Bearer ' + token
        }
    });

    const responseJson = await serverResponse.json();
    if (!serverResponse.ok) {
        return false
    }
    const fileNameToDownload = responseJson.fileName;
    const link = document.createElement("a");
    link.download = filename;
    link.href = BACKUP_API + `/download/${fileNameToDownload}?_ticket=${token}`;
    link.click();
    return true;
}


export function downloadLogFilesBackup() {

    const filename = new Date().toISOString() + '_files.zip'

    //const token = localStorage.getItem('access_token');
    const token = sessionStorage.getItem('access_token');

    return fetch(`${BACKUP_API}/files?_ticket=${token}`)
        .then(async res => {
            const response = await res.blob();

            if (!res.ok) {
                return null
            }

            fileSaver.saveAs(response, filename);
            return true;
        })

}



export function restoreDatabaseBackup(file) {
    showInfoToast("Starting system restoring", "Restore System", '', true)
    const formData = new FormData();
    formData.append("dump", file);
    return fetch(`${BACKUP_API}`,
        {
            method: 'POST',
            headers: {
                ...getAuthHeader()
            },
            body: formData
        }).then(async response => {
            if (!response.ok) {
                const json = await response.json();
                showDangerToast(`${json.message || 'Something went wrong'}`, `Error ${response.status}`, 'Check that the dump is not corrupted')
            } else {
                showSuccessToast('Application data was restored', 'Restore System')
            }

            return response.ok;
        })
}